'use client'

import { createContext, ReactNode, useContext } from 'react'
import type { WidgetAppearance } from '@/lib/widget-appearance'

interface Config {
  websocketUrl: string
  apiUrl: string
  fileServiceUrl: string
  siteId?: string | null
  appearance?: WidgetAppearance
}

export const ConfigContext = createContext<Config>({ websocketUrl: '', apiUrl: '', fileServiceUrl: '' })

export function useConfig() {
  return useContext(ConfigContext)
}

export default function ConfigProvider({ children, config }: { children: ReactNode; config: Config }) {
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
}
